<template>
  <div class="get-away-list-desc">
    <p>
      <Lang
        by-key="get-away-landing-description-1"
        :params="{ location: locationLabel }"
      />
    </p>

    <p>
      <Lang
        by-key="get-away-landing-description-2"
        :params="{ location: locationLabel }"
      />
      <span v-if="collapsed">..</span>
    </p>

    <p v-if="!collapsed">
      <Lang
        by-key="get-away-landing-description-3"
        :params="{ location: locationLabel }"
      />
    </p>

    <p v-if="!collapsed">
      <Lang
        by-key="get-away-landing-description-4"
        :params="{ location: locationLabel }"
      />
    </p>

    <p v-if="!collapsed">
      <Lang
        by-key="get-away-landing-description-5"
        :params="{ location: locationLabel }"
      />
    </p>

    <button
      class="get-away-list-desc__expand-btn"
      @click="toggleCollapsed"
    >
      <Lang
        v-if="collapsed"
        by-key="see-more"
        capitalize-first
      />
      <Lang
        v-else
        by-key="see-less"
        capitalize-first
      />
    </button>
  </div>
</template>

<script lang="ts">
import { Location } from '@/core/ts/entity/Location'
import { translate } from '~/core/ts/util/translate'

export default defineNuxtComponent({
  props: {
    location: { type: Object as PropType<Location | null>, default: () => null },
  },
  setup(props) {
    const collapsed = ref(true)

    function toggleCollapsed() {
      collapsed.value = !collapsed.value
    }

    const locationLabel = translate({
      es: props.location ? ' en '.concat(props.location.label) : '',
      pt: props.location ? ' em '.concat(props.location.label) : '',
    })

    return {
      collapsed,
      toggleCollapsed,

      locationLabel,
    }
  },
})
</script>

<style lang="scss" scoped>
.get-away-list-desc {
  @apply px-2;

  @screen lg {
    @apply px-0;
  }

  &__expand-btn {
    @apply underline;
  }

  p {
    @apply my-2;
  }
}
</style>
